module.exports = __webpack_public_path__ + "assets/language-squares/zh-HK@2x-691de990e3f0b55484828e1a5de79ff7.jpg";